export const CASCADING_CARD = '/cascading_card'

export const INICIO = '/inicio'
export const SERVICIOS = '/servicios'
export const CONTACTENOS = '/contactenos'
export const QUIENES_SOMOS = '/quienes_somos'

export const REGENCIA_QUIMICA_INFO = '/regencia_quimica_info'
export const REGENCIA_QUIMICA_COTIZACION = '/regencia_quimica_cotizacion'

// export const SERVICIOS_REGENCIA_QUIMICA = '/servicios_regencia_quimica'
 



// WEBPACK FOOTER //
// ./src/rutas/rutas.js